import { Pipe, PipeTransform } from "@angular/core";
import { DateHelper } from '@app/date-helper';

@Pipe({
  name: 'dayToDate',
  standalone: true
})
export class DayToDatePipe implements PipeTransform {

  public transform(i: number, month: number, startDay: number, year: number): string {

    // let t = new Date();
    // let n = DateHelper.normalizeDateToUTC(t);
    // n.setMonth(month);
    // n.setDate(i - startDay - 1);

    // let t = Date.UTC(2024, month, i - startDay - 1);
    let t = Date.UTC(year, month, i - startDay);
    let n = new Date(t);

    return DateHelper.normalizeDateToDateString(n);
  }
}
